// extracted by css-extract-rspack-plugin
export default {"error":"_cd80c622"};